export default "__VITE_ASSET__B3k4UfXa__"